import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Module10Logos {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
        cache.container = document.querySelectorAll('.module-10_logos');
        cache.arrowLeft = document.querySelectorAll('.module-10_logos .arrow_left');
        cache.arrowRight = document.querySelectorAll('.module-10_logos .arrow_right');
    };

    let registerEvents = () => {
        for (let i = 0; i < cache.container.length; i++) {
            const logo_wrapper = cache.container[i].querySelector('.logo_wrapper');
            const logo_inner = cache.container[i].querySelector('.logo_inner');
            if(logo_inner.scrollWidth <= logo_wrapper.offsetWidth) {
                cache.container[i].querySelector('.container .right').style.display = "none";
            }
        }
        for (let i = 0; i < cache.arrowLeft.length; i++) {
            cache.arrowLeft[i].addEventListener('click',scrollLeft);
        }
        for (let i = 0; i < cache.arrowRight.length; i++) {
            cache.arrowRight[i].addEventListener('click',scrollRight);
        }
    };

    let scrollLeft = function() {
        const parent = this.closest('.module-10_logos');
        const container = parent.querySelector('.logo_wrapper');
        const inner = container.querySelector('.logo_inner');
        const logo = container.querySelector('.logo').offsetWidth;

        if((container.offsetWidth + container.scrollLeft - logo) < container.offsetWidth) {
            anime({
                targets: container,
                duration: 400,
                scrollLeft: container.scrollWidth,
                easing: 'easeInOutCubic',
            });
        }
        else {
            anime({
                targets: container,
                duration: 400,
                scrollLeft: (container.scrollLeft - logo),
                easing: 'easeInOutCubic',
            });
        }
    }

    let scrollRight = function() {
        const parent = this.closest('.module-10_logos');
        const container = parent.querySelector('.logo_wrapper');
        const inner = container.querySelector('.logo_inner');
        const logo = container.querySelector('.logo').offsetWidth;

        if((container.offsetWidth + container.scrollLeft + logo) > inner.scrollWidth) {
            anime({
                targets: container,
                duration: 400,
                scrollLeft: 0,
                easing: 'easeInOutCubic',
            });
        }
        else {
            anime({
                targets: container,
                duration: 400,
                scrollLeft: (container.scrollLeft + logo),
                easing: 'easeInOutCubic',
            });
        }
    }

    initFunc();
  };
}
export { Module10Logos }